import React, { useEffect, ReactNode } from "react"
import { Button, Typography, IconButton, Box } from "@material-ui/core"
import { useDispatch, useSelector } from "react-redux"
import { getStripeRefLinkAsync } from "../../SupplierPayment/supplierPaymentSlice"
import { RootState } from "typesafe-actions"
import StripeDashboardButton from "../../SupplierPayment/components/StripeDashboardButton"
import { StripeConnectionStatus } from "../../api/models/QuotedData"
import { green, red, orange } from "@material-ui/core/colors"
import { Refresh } from "@material-ui/icons"
import { getSupplierInfoAsyncThunk } from "../../Supplier/actions/SupplierActions"


function getStripeConnectionStatusLabel(status: StripeConnectionStatus): ReactNode {
    switch (status) {
        case StripeConnectionStatus.FullyOperable:
            return <span style={{ color: green[500] }}>Connected</span>

        case StripeConnectionStatus.NotConnected:
            return <span style={{ color: red[900] }}>Not connected</span>

        case StripeConnectionStatus.ActionRequired:
            return <span style={{ color: red[600] }}>Action required</span>

        case StripeConnectionStatus.PendingVerification:
            return <span style={{ color: orange[500] }}>Pending verification</span>

        case StripeConnectionStatus.Unknown:
            return <span style={{ color: red[500] }}>Unknown</span>

        default:
            return <span style={{ color: red[500] }}>Unknown</span>
    }
}

export default function SupplierPaymentDetails() {
    const dispatch = useDispatch()
    const _supplierPayment = useSelector((state: RootState) => state.supplierPaymentRdc)
    const _supplier = useSelector((state: RootState) => state.supplierRdc)

    useEffect(() => {
        if (!_supplier.supplierInfo && !_supplier.getSupplierInfoBusy)
            dispatch(getSupplierInfoAsyncThunk())

    }, [])

    useEffect(() => {
        if (_supplierPayment.stripeRegisterLink)
            window.open(_supplierPayment.stripeRegisterLink!)
    }, [_supplierPayment.stripeRegisterLink])


    return (
        <div>
            {_supplier.supplierInfo &&
                <>
                    <Box display="flex">
                        <Box>
                            <Typography>Current status: <b>{getStripeConnectionStatusLabel(_supplier.supplierInfo!.stripeConnectionStatus!)}</b></Typography>
                        </Box>
                        <Box>
                            <IconButton size="small" onClick={() => { dispatch(getSupplierInfoAsyncThunk()) }}><Refresh style={{ width: '20px', height: '20px' }} /></IconButton>
                        </Box>
                    </Box>
                    <br />

                    {_supplier.supplierInfo!.stripeConnectionStatus === StripeConnectionStatus.NotConnected ?
                        <Button color="secondary" onClick={() => { dispatch(getStripeRefLinkAsync()) }} variant="contained" >Connect Payout</Button>
                        :
                        <StripeDashboardButton />
                    }
                </>
            }
        </div>
    )
}